import React from 'react';
import './Process.css';

import { Heading, ProcessStep } from '../../../components';
import { process } from '../../../constants';

// Import Swiper core and required modules
import { Autoplay } from 'swiper';
 
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
 
// Import Swiper styles  
import 'swiper/css'; 
import 'swiper/css/pagination';



const Process = () => { 

  return (
    <section className='process'>

      {/* Section heading */}
      <Heading title={'Our Approach'} subTitle={'Our Approach'} />

      <Swiper
        // Install Swiper modules
        modules={[Autoplay]}
        spaceBetween={10}
        loop={true}
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        breakpoints={{
          // When window width is >= 768px
          450: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
          },
          990: {
            slidesPerView: 3,
          },
        }} >
        {/* Map over the process array to render each process step */}
        {process.map((step) => {

          return (
            <SwiperSlide key={step.id}>

              <ProcessStep
                id={step.id}
                image={step.image}
                title={step.title}
                content={step.content}
              />

            </SwiperSlide>
          );
        })}
      </Swiper>

    </section>
  )
}

export default Process;